import React from "react";
import type {WorkflowStageContext} from "./stage";
import {AmountAndRateStage, ReceiptStage, RequisitesStage, SectionTitle} from "./WorkflowStageControls";
import {PayinParts, PayinStageBadge} from "../PayinParts";

export function StandardPayin({context}: {context: WorkflowStageContext}): JSX.Element {
    return (
        <>
            {!context.payment.payinParts && <PayinStageBadge issued={Boolean(context.payment.payinRequisites)}/>}
            {!context.payment.payinParts && <RequisitesStage
                number="1"
                title="Реквизиты приёма"
                hint={context.payment.payinRequisites ? "ожидание оплаты" : "обязательно"}
                context={context}
            />}
            {context.payment.payinParts ? <PayinParts orderId={context.payment.orderId} state={context.payment.payinParts} audience="operator" onConfirm={context.onConfirmPart} onReplace={context.onReplacePart} active={context.payment.status === "pending" || context.payment.status === "appeal"}/> : context.payment.merchantPortalIn ? (
                <section className="details-section">
                    <SectionTitle number="2" hint="чек мерчанта">Подтверждение оплаты</SectionTitle>
                    <div className="details-lock-hint" role="status">
                        {context.payment.merchantPortalReceiptReady ? "Чек мерчанта принят. Проверьте поступление рублей перед подтверждением." : "Ожидаем чек мерчанта по актуальным реквизитам."}
                    </div>
                </section>
            ) : <ReceiptStage number="2" title="Подтверждение получения" hint="обязательно" context={context}/>}
            <AmountAndRateStage number="3" title="Фактически получено" isIncome context={context}/>
        </>
    );
}
